import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import classNames from 'classnames';
import * as React from 'react';

import { CloseBtn } from '../../../../../common/components/close_button/index';

const style = require('./index.css');

export interface IVideoBannerProps {
  context: IAdFoxBannerContext;
}

interface IVideoBannerState {
  isPlay: boolean;
  isVisible: boolean;
}

export class VideoBanner extends React.Component<IVideoBannerProps, IVideoBannerState> {
  private video: HTMLVideoElement | null = null;

  public constructor(props: IVideoBannerProps) {
    super(props);

    this.state = { isPlay: true, isVisible: true };
  }

  public render() {
    if (!this.state.isVisible) {
      return null;
    }

    return (
      <div className={style['videoContainer']}>
        {!this.state.isPlay && (
          <div className={style['buttonsContainer']}>
            <div className={classNames(style['button'], style['button--restart'])} onClick={() => this.replayHandler()}>
              Посмотреть еще раз
            </div>
            <div
              className={classNames(style['button'], style['button--toSite'])}
              onClick={() => this.goToSiteHandler()}
            >
              Перейти на сайт
            </div>
          </div>
        )}
        <video
          loop={false}
          autoPlay
          muted
          className={this.state.isPlay ? style['play'] : style['paused']}
          onEnded={this.videoEndHandler}
          ref={videoElement => (this.video = videoElement)}
        >
          <source src={this.props.context.mp4} type="video/mp4" />
          <source src={this.props.context.webm} type="video/webm" />
        </video>
        <CloseBtn
          onClick={() => {
            this.setState({ isVisible: false });
          }}
          isTransparent
          className={style.closeBtn}
        />
      </div>
    );
  }

  private videoEndHandler = () => {
    this.setState({
      isPlay: false,
    });
  };

  private replayHandler() {
    if (this.video) {
      this.video.play();
      this.setState({
        isPlay: true,
      });
    }
  }

  private goToSiteHandler() {
    window.open(this.props.context.url);
  }
}
